import React, { useEffect, useRef } from "react";
import { Modal, ModalHeader, ModalBody, ListGroup, ListGroupItem, Button } from '@/Components/ui';
;
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import { API_TICKETS, getDataFromUrl, deleteTicketItem, changeTicket, refundTicketItem } from "../../../api";
import moment from "moment";
import { dialogService } from "@/utils/dialogService";
import { buildServerListUrl } from "@/utils/serverListQuery";
const STATE_MODAL_FOCUS = {
    0: "사용처리",
    1: "사용취소",
};
const UserDetailTicketList = ({ userPhoneNum }) => {
    const navigate = useNavigate();
    const tableName = "ticket";
    const columns = React.useMemo(() => [
        {
            Header: '번호',
            accessor: 'row_number',
            id: 'row_number',
        },
        {
            Header: 'ID',
            accessor: 'id',
            id: 'id',
        },
        {
            Header: '고객',
            accessor: '고객',
            id: '',
        },
        {
            Header: '상품',
            accessor: '상품',
            id: 'order',
        },
        {
            Header: '상태',
            accessor: '상태',
            id: 'state',
        },
        {
            Header: '사용일',
            accessor: '사용일',
            id: 'used_date',
            Cell: (cellProps) => {
                return <span>{cellProps.row.original["사용일"] !== "-" ? moment(cellProps.row.original["사용일"]).format("YYYY-MM-DD HH:mm") : ""}</span>;
            }
        },
        {
            Header: '만료일',
            accessor: '만료일',
            id: 'expiration_date',
        },
        {
            Header: 'Actions',
            accessor: 'Actions',
            id: '',
            Cell: (cellProps) => {
                return (<div className="d-flex gap-2">
                            {(cellProps.row.original["상태"] !== "사용함") && <div className="edit">
                                <div className="text" style={{ cursor: "pointer", color: "#3577f1" }} onClick={() => {
                            setCheckedRecords([cellProps.row.original]);
                            setStateChangeModal(true);
                            setFocusState(0);
                        }}>
                                    <i className="ri-pencil-fill fs-16"></i>
                                </div>
                            </div>}
                            {(cellProps.row.original["상태"] !== "사용안함") && <div className="edit">
                                <div className="text" style={{ cursor: "pointer", color: "#ffbe0b" }} onClick={() => {
                            setCheckedRecords([cellProps.row.original]);
                            setStateChangeModal(true);
                            setFocusState(1);
                        }}>
                                    <i className="ri-pencil-fill fs-16"></i>
                                </div>
                            </div>}
                            <div className="remove">
                                <div className="text-danger" style={{ cursor: "pointer" }} onClick={() => {
                        setCheckedRecords([cellProps.row.original]);
                        togDeleteModal();
                    }}>
                                    <i className="ri-delete-bin-5-fill fs-16"></i>
                                </div>
                            </div>
                        </div>);
            }
        },
    ], []);
    const [data, setData] = React.useState([]);
    const [previous, setPrevious] = React.useState("");
    const [next, setNext] = React.useState("");
    const [count, setCount] = React.useState("");
    const [dataQuery, setDataQuery] = React.useState({});
    const onRequestData = (_url) => {
        getDataFromUrl(_url)
            .then((data) => {
            setData(data.results);
            setPrevious(data.previous);
            setNext(data.next);
            setCount(data.count);
            // if (isSearch) calcTotalPageCount(data.count, (data.results).length);
        })
            .catch((e) => { console.log(e); });
    };
    const refetch = () => {
        onRequestData(buildServerListUrl(API_TICKETS, { search: userPhoneNum, ...dataQuery }));
    };
    React.useEffect(() => {
        if (!previous && !next) {
            refetch();
        }
    }, []);
    const [checkedRecords, setCheckedRecords] = React.useState([]);
    const [stateChangeModal, setStateChangeModal] = React.useState(false);
    const [focusState, setFocusState] = React.useState(-1); // 0 : "사용처리", 1 : "사용취소"
    const [deleteModal, setDeleteModal] = React.useState(false);
    const togDeleteModal = () => setDeleteModal(!deleteModal);
    const clearSelectedOptions = () => {
        const ele = document.querySelectorAll(`.${tableName}.customerCheckBox:checked`);
        const checkall = document.getElementById(`checkBoxAll-${tableName}`);
        ele.forEach((element) => {
            element.checked = false;
        });
        if (checkall)
            checkall.checked = false;
    };
    const deleteRecords = () => {
        (async () => {
            for (let i = 0; i < checkedRecords.length; i++) {
                const record = checkedRecords[i];
                await deleteTicketItem(record.id);
            }
            await dialogService.handleAlert("삭제 완료");
        })().then(() => refetch()).catch((e) => console.log(e));
    };
    const refundRecords = async () => {
        if (await dialogService.confirm("환불처리를 진행하시겠습니까? CRM 환불은 고객 취소 정책과 관계없이 선택한 티켓만 관리자 강제 개별취소로 처리됩니다.") === false)
            return;
        (async () => {
            for (let i = 0; i < checkedRecords.length; i++) {
                const record = checkedRecords[i];
                await refundTicketItem(record.id);
            }
            await dialogService.handleAlert("환불 완료");
        })().then(() => refetch()).catch((e) => console.log(e));
    };
    const changeState = () => {
        (async () => {
            if (focusState === 0) {
                for (let i = 0; i < checkedRecords.length; i++) {
                    const record = checkedRecords[i];
                    if (record["상태"] === "사용안함") {
                        await changeTicket(record.id, "사용함");
                    }
                }
                await dialogService.handleAlert("사용처리 완료");
            }
            else if (focusState === 1) {
                for (let i = 0; i < checkedRecords.length; i++) {
                    const record = checkedRecords[i];
                    if (record["상태"] === "사용함") {
                        await changeTicket(record.id, "사용안함");
                    }
                }
                await dialogService.handleAlert("사용취소 완료");
            }
        })().then(() => refetch()).catch((e) => console.log(e));
    };
    return (<div>

            {/* 티켓 상태 전환 Modal */}
            <Modal id="topmodal" isOpen={stateChangeModal} onClose={() => {
            clearSelectedOptions();
            togStateChangeModal();
        }}>
                <ModalHeader className="modal-title" id="myModalLabel" toggle={() => {
            clearSelectedOptions();
            togStateChangeModal();
        }}>
                    {STATE_MODAL_FOCUS[focusState]}
                </ModalHeader>
                <ModalBody className="text-center p-5">
                    <div className="mt-4">
                        <h6 className="mb-3">{`선택하신 사용자의 티켓을 모두 ${STATE_MODAL_FOCUS[focusState]}하시겠습니까?`}</h6>
                        <p className="text-muted mb-4">{focusState === 0 ? '"사용안함"인 티켓만 "사용함"으로 변경됩니다.' : '"사용함"인 티켓만 "사용안함"으로 변경됩니다.'}</p>
                        {checkedRecords.length > 0 ? (<div className="live-preview" style={{ height: 200, overflowY: "scroll" }}>
                                <ListGroup>
                                    {checkedRecords.map((record) => {
                return <ListGroupItem key={record.id} style={{ whiteSpace: "pre-line" }}>{`${record.id} - ${record["고객"]} - ${record["상품"]}`}</ListGroupItem>;
            })}
                                </ListGroup>
                            </div>) : (<span>{`${STATE_MODAL_FOCUS[focusState]}할 사용자 티켓을 먼저 선택해주세요.`}</span>)}
                        <br />
                        <br />
                        <div className="hstack gap-2 justify-content-center">
                            <button className={focusState === 0 ? "btn btn-soft-secondary fw-medium" : "btn btn-soft-warning fw-medium"} onClick={() => {
            clearSelectedOptions();
            togStateChangeModal();
        }}>
                                <i className="ri-close-line me-1 align-middle"></i> Close
                            </button>
                            <button className={focusState === 0 ? "btn btn-secondary" : "btn btn-warning"} onClick={() => {
            changeState();
            setStateChangeModal(false);
        }} disabled={checkedRecords.length === 0}>
                                {STATE_MODAL_FOCUS[focusState]}
                            </button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>


            {/* Delete Modal */}
            <Modal id="topmodal" isOpen={deleteModal} onClose={() => {
            clearSelectedOptions();
            togDeleteModal();
        }}>
                <ModalHeader className="modal-title" id="myModalLabel" toggle={() => {
            clearSelectedOptions();
            togDeleteModal();
        }}>
                    삭제/환불
                </ModalHeader>
                <ModalBody className="text-center p-5">
                    <div className="mt-4">
                        <h5 className="mb-3">선택하신 사용자의 티켓을 모두 삭제하시겠습니까?</h5>
                        {checkedRecords.length > 0 ? (<div className="live-preview" style={{ height: 200, overflowY: "scroll" }}>
                                <ListGroup>
                                    {checkedRecords.map((record) => {
                return <ListGroupItem key={record.id} style={{ whiteSpace: "pre-line" }}>{`${record.id} - ${record["고객"]} - ${record["상품"]}`}</ListGroupItem>;
            })}
                                </ListGroup>
                            </div>) : (<span>삭제를 원하시는 사용자 티켓을 먼저 선택해주세요.</span>)}
                        <br />
                        <br />
                        <p>티켓내역 삭제(데이터만 삭제)하는 경우 PG사(토스)에서 직접 환불 처리해주셔야 합니다.</p>
                        <div className="hstack gap-2 justify-content-center">
                            <Button onClick={() => {
            clearSelectedOptions();
            togDeleteModal();
        }} className="bg-gradient-light fw-medium">
                                <i className="ri-close-line me-1 align-middle"></i> 닫기
                            </Button>
                            <Button onClick={() => {
            deleteRecords();
            setDeleteModal(false);
        }} disabled={checkedRecords.length === 0} color="danger">
                                티켓내역 삭제
                            </Button>
                            <Button onClick={() => {
            refundRecords();
            setDeleteModal(false);
        }} disabled={checkedRecords.length === 0} color="danger">
                                환불처리
                            </Button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>

            <div>
                <React.Fragment>
                    <ServerPaginatedTable id="reservations-table" serachable={false} tableQuery={{ search: userPhoneNum }} url={API_TICKETS} columns={columns} data={data} previous={previous} next={next} count={count} onRequestData={onRequestData} onChangeQuery={setDataQuery} categories={[]}/>
                </React.Fragment>
            </div>
        </div>);
};
export default UserDetailTicketList;
